import type { EntityIcon } from "../../api/types.gen.ts";
import { t } from "../../i18n/index.ts";
import { usesPills } from "../../lib/state.ts";
import { EntityChip, EntityGlyph } from "../../ui/EntityGlyph.tsx";

/**
 * An item's entity, as the person chose the app to look: a chip in its tint (pills), or its icon and name (icons).
 * Without an entity ("No entity"): a hollow dot and the words, quietly, either way.
 */
export function EntityLabel({
  entity,
  large = false,
}: {
  entity: { name: string; icon?: EntityIcon | null } | null | undefined;
  /** Body-sized (a table's or card's), not small print. */
  large?: boolean;
}) {
  if (!entity) {
    return (
      <span class={`inline-flex items-center gap-1 text-zinc-500 ${large ? "text-sm" : "text-xs"}`}>
        <EntityGlyph icon={null} size={large ? 16 : 14} empty="none" />
        {t("items.noEntity")}
      </span>
    );
  }
  if (usesPills()) {
    return <EntityChip entity={entity} large={large} />;
  }
  return (
    <span class={`inline-flex min-w-0 items-center gap-1.5 ${large ? "" : "text-xs text-zinc-500"}`}>
      <EntityGlyph icon={entity.icon} size={large ? 18 : 14} empty="dot" />
      <span class="truncate">{entity.name}</span>
    </span>
  );
}
